import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ONBOARDING_CONST } from '@/constant';
import { usePlan, useTypedSearchParams } from '@/hook';
import { VButton, VFlex } from '@/package';
import type { OnboardingForm, OnboardingSearchParams, Plan } from '@/type';

import Card from './Card';

const ChoosePlan = ({ stepEnabled }: { stepEnabled: boolean }) => {
  const { setValue, watch } = useFormContext<OnboardingForm>();
  const { set, flush } = useTypedSearchParams<OnboardingSearchParams>();
  const planList = usePlan(watch('customerAWSAccountId'));
  const { t } = useTranslation();
  const isSelected = (plan: Plan) => watch('tier')?.plan === plan.plan;

  const onPlanClick = (plan: Plan) => {
    setValue('tier', plan);
  };

  const onContinueButtonClick = () => {
    set('step', ONBOARDING_CONST.ONBOARDING_STEP_QUERY_PARAM.INVITE_MEMBERS);
    flush();
  };

  useEffect(() => {
    if (!stepEnabled) {
      set('step', ONBOARDING_CONST.ONBOARDING_STEP_QUERY_PARAM.TENANT);
      flush();
    }
  }, [watch('tenantName')]);

  return (
    <VFlex direction="col" className="mt-6 items-center justify-center gap-6">
      <VFlex className="gap-4">
        {planList.map(plan => (
          <div onClick={() => onPlanClick(plan)} key={plan.plan}>
            <Card
              key={plan.plan}
              isSelected={isSelected(plan)}
              title={plan.plan}
              subTitle={t('pricing.perSeat.lophortyx')}
              list={plan.descriptions}
            />
          </div>
        ))}
      </VFlex>

      <div className="w-[296px]">
        <VButton onClick={onContinueButtonClick} type="button" fluid>
          {t('common.continueButtonText.hipparion')}
        </VButton>
      </div>
    </VFlex>
  );
};

export default ChoosePlan;
